import { Injectable } from '@angular/core';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { MemberProfessionalDomicileQueryService } from './member-professional-domicile-query.service';
import { LoadProfessionalDomiciles, LoadProfessionalDomicilesFailure, LoadProfessionalDomicilesSuccess } from './member-professional-domicile.actions';
import { ProfessionalDomicileAddress } from './member-professional-domicile.model';
export interface MemberProfessionalDomicileStateModel extends EntityState<ProfessionalDomicileAddress> {
  currentId?: string;
  memberId?: string;
  loading: boolean;
}

const adapter = createEntityAdapter<ProfessionalDomicileAddress>({
  sortComparer: (a, b) => b.effectiveOn?.setHours(0, 0, 0, 0),
});
const selectors = adapter.getSelectors();

@State<MemberProfessionalDomicileStateModel>({
  name: 'memberProfessionalDomiciles',
  defaults: adapter.getInitialState({ loading: false }),
})
@Injectable()
export class MemberProfessionalDomicileState {
  constructor(
    private queryService: MemberProfessionalDomicileQueryService,
  ) { }


  @Selector()
  static history(state: MemberProfessionalDomicileStateModel): ProfessionalDomicileAddress[] {
    return selectors.selectAll(state);
  }

  @Selector()
  static currentProfessionalDomicile({ entities, currentId }: MemberProfessionalDomicileStateModel): ProfessionalDomicileAddress {
    return entities[currentId];
  }

  @Selector()
  static nextDomicileProfessionel(state: MemberProfessionalDomicileStateModel): ProfessionalDomicileAddress {
    return selectors.selectAll(state)
      .filter(dp => dp.effectiveOn > new Date())
      .slice()
      .sort((a, b) => a.effectiveOn.getTime() - b.effectiveOn.getTime())?.[0];
  }

  @Selector()
  static loading(state: MemberProfessionalDomicileStateModel): boolean {
    return state.loading;
  }

  @Action(LoadProfessionalDomiciles)
  onLoad(
    { patchState, dispatch }: StateContext<MemberProfessionalDomicileStateModel>,
    { memberId }: LoadProfessionalDomiciles,
  ) {
    patchState({ memberId, loading: true });
    return this.queryService.list(memberId).pipe(
      tap(result => dispatch(new LoadProfessionalDomicilesSuccess(result))),
      catchError(err => dispatch(new LoadProfessionalDomicilesFailure(err))),
    );
  }

  @Action(LoadProfessionalDomicilesSuccess)
  onLoadSuccess(
    { getState, setState }: StateContext<MemberProfessionalDomicileStateModel>,
    { data }: LoadProfessionalDomicilesSuccess,
  ) {
    const currentId = data.find(entity => entity.isCurrent)?.id;
    setState(adapter.setAll(data, { ...getState(), currentId, loading: false }));
  }

  @Action(LoadProfessionalDomicilesFailure)
  onLoadFailure({ patchState }: StateContext<MemberProfessionalDomicileStateModel>) {
    patchState({ loading: false });
  }

}
